import { v4 as uuid } from "uuid";
import { USER_ROLES, UserScope } from "interfaces";

export const ListOfRoles = ({ roles }: { roles: UserScope[] }) => {
  return (
    <ul>
      {roles.map((role) => (
        <li key={uuid()}>{USER_ROLES.texts[role]}</li>
      ))}
    </ul>
  );
};
